<template>
  <div class="container">
      <mt-header fixed :title="service.name+'的工程'" class="head">
    <router-link to="/main" slot="left">
      <mt-button icon="back"></mt-button>
    </router-link>
  </mt-header>
      <div class="title">
          <div class="c_m_t_10">
            <div class="c_center uname c_red c_nowrap">
              ¥ {{service.totalamount?service.totalamount:'0'}}
              <span class="c_white" style="">{{service.servicestate==1?'已接单':'待接单'}}</span>
            </div>
            <div class="c_center opera">
                <div class="spa bg_blue" v-if="service.servicestate==0">
                  <router-link to="/update">
                    工序更新
                  </router-link>
                </div>
                <div v-else class="spa bg_blue" @click="toimgupdate(service.billid)">
                  工序更新
                </div>
            </div>
          </div>
      </div>

      <div class="select">
          <!--<div class="navbar">-->
            <!--<div class="c_center c_blue">工程日志</div>-->
          <!--</div>-->
          <!-- 日志详情 -->
          <div class="dets"  v-show="msg.length>0">
              <div class="c_m_b_10 item" v-for="(n,index) in msg" :key="index" style="display:flex">
                <div class="img c_flex c_flex_center c_rela">
                  <div class="round"></div>
                  <div class="solid"></div>
                </div>
                <div class="c_flex_1 bg_white">
                    <div class="msg">
                      <span>{{n.creator}}</span>
                      <span>{{n.result}}</span>
                      <span>{{n.action}}</span><br>
                      <div class=" c_gray c_m_t_10" >{{ n.ts | getDatetime}}</div>
                    </div>
                </div>
              </div>
          </div>
      </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      msg: '',
      selected:'1',
      service:{},
    }
  },
  mounted:function(){
      this.loadList();
      this.loadLog();
  },
  methods:{
    loadList:function(){
      var service = JSON.parse(localStorage['obj']);
      if(!service || !service.billid){
        this.$router.push('/main');
      }else{
        this.service = service;
      }
    },
    loadLog:function(){
        var $that = this;
        this.$ajax.get(this.$$api.mobile.getServiceLog,{
          search_serviceid:this.service.billid
        },function (res) {
            var msg=res.data.detailMsg.data.content;
            if(msg){
              $that.msg = msg;
            }
        });
    },
    toimgupdate(val){
      this.$router.push({path:'/imgupdate'});
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .title{
    /*display: flex;*/
    width:100%;
    height:3rem;
  }
  .uname{
    font-size:12vw;
    color:#32475B;
  }
  .spa a{
    color: #fff;
  }
  .spa{
    display: block;
    font-size: 0.5rem;
    width: 80%;
    line-height: .5rem;
    margin: 3vw auto;
    padding: 3vw;
    color: #fff;
    border-radius: 3px;
  }
  .round{
    width: .7rem;
    height: .7rem;
    border-radius: .5rem;
    border:1px solid #ccc;
    z-index: 5;
  }

  .msg{
    border: 1px solid #ccc;
    border-radius: 3px;
    box-shadow: #ccc 1px 1px 1px;
    outline: none;
    box-sizing: border-box;
    color: #63789d;
    box-sizing: border-box;
    width: 100%;
    padding: 3vw;
  }

  .msg span[data-v-8d64e93c]{
    color: #63789d
  }

  .select{
    width: 100%;
    margin-top: 10vw;
  }
  .dets{
    padding: 3.226vw;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
  }
  .dets .img{
    width: 10vw;
    padding-right: 3vw;
  }
  .uname span {
    font-size: 4vw;background: #aaa;padding: 1vw 2vw;border-radius: 10px;
  }
  .solid{
    position: absolute;
    top: 15vw;
    bottom: 0;
    z-index: 2;
    width: 0;
    height: 10vw;
    border: 1px solid #ccc;
  }
  .item:last-child .solid{
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/details.vue